export const getFavoriteUpdateStatus = (accountType, nextFavorites) => {
  if (!accountType) return 'account-loading';
  if (accountType === 'free' && nextFavorites.length > 1) return 'limit-reached';
  return 'allowed';
};
